import React from 'react';
import { motion } from 'framer-motion';
import { PricingBlock } from '../ui/PricingBlock';
import { CTAButton } from '../ui/CTAButton';
export const FinalCTA = () => {
  return <section className="relative w-full py-32 px-6 overflow-hidden bg-cosmic-900 border-t border-white/5" data-id="element-20">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-amber-900/20 via-cosmic-900 to-cosmic-900 pointer-events-none" data-id="element-21" />

      <div className="relative z-10 max-w-3xl mx-auto text-center flex flex-col items-center" data-id="element-22">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-23">
          <h2 className="text-4xl md:text-5xl font-serif text-amber-400 mb-8 leading-tight" data-id="element-24">
            Has pasado años buscando el mapa.
          </h2>
          <p className="text-2xl md:text-3xl font-serif italic text-gray-300 mb-12" data-id="element-25">
            El territorio siempre estuvo dentro de ti.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} id="final-cta" className="w-full max-w-md mx-auto bg-cosmic-800/80 backdrop-blur-sm p-8 rounded-2xl border border-amber-500/20 shadow-[0_0_30px_rgba(245,197,66,0.1)]" data-id="element-26">
          <h3 className="text-2xl font-serif text-white mb-2" data-id="element-27">
            Abre el libro.
          </h3>
          <p className="text-amber-200/80 mb-6 font-serif italic text-lg" data-id="element-28">
            Recuerda lo que ya sabes.
          </p>

          <PricingBlock data-id="element-29" />

          <div className="mt-8" data-id="element-30">
            <CTAButton className="w-full" isFinal data-id="element-31">
              Comenzar el Viaje <span className="ml-2" data-id="element-32">→</span>
            </CTAButton>
          </div>
        </motion.div>
      </div>
    </section>;
};